<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" :title=title :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="proofbill" :store="store" selectType="radio" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			invoiceNumber: {
				default: () => {
					return null
				}
			},
			currentrow: {
				default: () => {
					return null
				}
			},
			checkeddata: {
				default: () => {
					return []
				}
			},
			invoicedata: {
				default: () => {
					return {}
				}
			},
			
		},
		data() {
			return {
				title:'小望订单商品',
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'orderId',
						title: '订单号',	
					},{
						field: 'realskuId',
						title: 'sku编码',	
					},{
						field: 'goods_name',
						title: '商品名称',	
					},{
						field: 'specValue',
						title: '规格型号',
					},{
						field: 'nums',
						title: '数量',
					},{
						field: 'tp_payment',
						title: '付款',
					}],
					buttons:[],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: false,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			
			
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list_footerField = [
				{field:'nums',toFixed:2},
				{field:'tp_payment',toFixed:2},
			]
			this.box.list = this.list
			this.box.show = this.show
	
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
					let boxdata =  this.box.getTable().getTableData().tableData
					boxdata.forEach((row)=>{
						let target = this.checkeddata.find((item)=>{
							return row.id == item.id
						})
						if(target){
							this.box.getTable().setCheckboxRow(row,true)
						}
					})
					
				}
			},
			initList() {
				this.title =  '小望订单商品【'+this.currentrow.cargoName+'】' + this.currentrow.amount
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list() {
				//console.log(this.store)
				return new Promise((resolve, reject) => {
					if(this.store.xwtradedata.length){
						resolve({list:this.store.xwtradedata})
					}else{
						this.$api.invoice.getoutputinvoicematchinfo({
							type: 'xwtrade',
							orderPlant:this.invoicedata.orderPlant,
							invoiceNumber: this.invoiceNumber
						}).then((res) => {
							res.forEach((item)=>{
								item.id = Math.random()
							})
							this.store.xwtradedata = res
							resolve({list:res})
						}, () => {
							reject()
						})
					}

				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>